export default {
  user: {
    search: {
      company: '公司名称',
      companyPlaceholder: '请输入公司名称',
    },
    table: {
      userName: '用户名称',
    },
  },
};
